export function isLoggedIn() {
    return localStorage.getItem("isLoggedIn") == 'true';
}
export function logIn() {
    localStorage.setItem("isLoggedIn", true);
}
export function setCurrentUser(dataObj){
    localStorage.setItem("current_user", JSON.stringify(dataObj));
}
export function getCurrentUser(){
    return JSON.parse(localStorage.getItem("current_user"));
}
export function getCurrentUserId(){
    return (JSON.parse(localStorage.getItem("current_user"))).id;
}
export function getCurrentUserCleanId(){
    return (JSON.parse(localStorage.getItem("current_user"))).clean_cloud_id;
}
export function loginAdmin() {
    localStorage.setItem("isAdmin", true);
}
export function isloginAdmin() {
    return localStorage.getItem("isAdmin") == 'true';
}

export function logOut() {
    localStorage.setItem("isLoggedIn", false);
    localStorage.setItem("isAdmin", false);
    localStorage.removeItem("current_user");
    

    localStorage.removeItem("delivery_date_wash");
    localStorage.removeItem("pickup_date_wash");
    localStorage.removeItem("pickup_timing_wash");
    localStorage.removeItem("wash_premium_charge_fee");
    localStorage.removeItem("wash_products");
    localStorage.removeItem("dry_clean_products");
    localStorage.removeItem("tailoring_products");
    localStorage.removeItem("pickup_date_dry_clean");
    localStorage.removeItem("pickup_timing_dry_clean");
    localStorage.removeItem("delivery_date_dry_clean");
    localStorage.removeItem("delivery_timing_dry_clean");
    localStorage.removeItem("delivery_date_dry_clean");
    localStorage.removeItem("pickup_date_tailoring");
    localStorage.removeItem("delivery_date_tailoring");
    localStorage.removeItem("pickup_timing_tailoring");
    localStorage.removeItem("delivery_date_tailoring");
    localStorage.removeItem("delivery_timing_tailoring");
    localStorage.removeItem("delivery_date_tailoring");
    localStorage.removeItem("delivery_timing_wash");
    localStorage.removeItem("is_individual");
    localStorage.removeItem("wash_same_day_delivery");

    localStorage.clear();
}

export function removeOrderLocalStorage() {
    
    localStorage.removeItem("delivery_date_wash");
    localStorage.removeItem("pickup_date_wash");
    localStorage.removeItem("pickup_timing_wash");
    localStorage.removeItem("wash_premium_charge_fee");
    localStorage.removeItem("wash_products");
    localStorage.removeItem("dry_clean_products");
    localStorage.removeItem("tailoring_products");
    localStorage.removeItem("pickup_date_dry_clean");
    localStorage.removeItem("pickup_timing_dry_clean");
    localStorage.removeItem("delivery_date_dry_clean");
    localStorage.removeItem("delivery_timing_dry_clean");
    localStorage.removeItem("delivery_date_dry_clean");
    localStorage.removeItem("pickup_date_tailoring");
    localStorage.removeItem("delivery_date_tailoring");
    localStorage.removeItem("pickup_timing_tailoring");
    localStorage.removeItem("delivery_date_tailoring");
    localStorage.removeItem("delivery_timing_tailoring");
    localStorage.removeItem("delivery_date_tailoring");
    localStorage.removeItem("delivery_timing_wash");
    localStorage.removeItem("is_individual");
    localStorage.removeItem("wash_same_day_delivery");
}


// WEBPACK FOOTER //
// ./src/utils/auth.js